import { OccupancyCharts } from '../../../_metronic/partials/widgets/charts/OccupancyCharts'

const OccuepancyReport = () => {
  return (
    <>
    <OccupancyCharts className='card-xl-stretch mb-xl-8' />
   </>
  )
}

export { OccuepancyReport }
